import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { AdditionalServiceData, GeneralPricingMode, Service } from '@mews-commander/data-access';
import { Taxation } from '@mews-commander/types';
import { getTaxationsByTaxEnvironmentCode } from '@mews-commander/legacy-entities/src/ducks/taxEnvironments';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { useCommanderSelector } from '@mews-commander/utils';
import { useGetReservationsForLinking } from './useGetReservationsForLinking';
import { useGetDefaultProductConsumeDate } from './useGetDefaultProductConsumeDate';

export const useDefaultFormValues = (service: Service, accountId: string, scopedReservationIds?: string[]) => {
    const reservations = useGetReservationsForLinking(accountId, scopedReservationIds);
    const { taxEnvironmentCode, pricing } = useCurrentEnterprise();
    const taxations: Taxation[] = useCommanderSelector((state) =>
        getTaxationsByTaxEnvironmentCode(state, { taxEnvironmentCode })
    );
    const isCompany = useCommanderSelector((state) => isAccountIdCompany(state, { accountId }));

    const { basePrice } = service.data.value as AdditionalServiceData;

    const empty = {} as Record<string, string>;

    taxations.forEach((taxation) => {
        empty[taxation.code] = '';
    });

    const defaultLinkedReservation = reservations ? reservations[0]?.reservationId : undefined;
    const getDefaultConsumeDate = useGetDefaultProductConsumeDate(accountId, scopedReservationIds);
    const defaultTaxValues = (basePrice.taxValues || []).reduce((accumulator, taxValue) => {
        const taxation = taxations.find((tax) => tax.taxRateCodes.includes(taxValue.taxRateCode));

        if (taxation) {
            accumulator[taxation.code] = taxValue.taxRateCode;
        }

        return accumulator;
    }, empty);

    return {
        defaultStartUtc: getDefaultConsumeDate(defaultLinkedReservation),
        defaultTaxValues,
        defaultAmount:
            (pricing === GeneralPricingMode.Net ? basePrice.netValue : basePrice.grossValue) || basePrice.value,
        ...(!isCompany && {
            defaultLinkedReservationId: defaultLinkedReservation,
        }),
    };
};
